import type { SelectOneItem as SelectOneItemType } from '@webforge-survey/shared';
import { ItemShell } from './ItemShell';

interface SelectOneItemProps {
  item: SelectOneItemType;
  value: string | null;
  error?: string;
  onChange: (value: string) => void;
}

/**
 * select_one : radio sémantique, conteneur `fieldset[role=radiogroup]`.
 * Chaque option est cliquable sur toute sa surface (label parent).
 */
export function SelectOneItem({ item, value, error, onChange }: SelectOneItemProps) {
  return (
    <ItemShell
      name={item.name}
      label={item.label}
      {...(item.hint !== undefined && { hint: item.hint })}
      {...(item.required !== undefined && { required: item.required })}
      {...(error !== undefined && { error })}
      role="radiogroup"
    >
      <div className="space-y-2 max-w-prose">
        {item.choices.map((choice) => {
          const selected = value === choice.value;
          const id = `${item.name}-${choice.value}`;
          return (
            <label
              key={choice.value}
              htmlFor={id}
              className={`option-card ${selected ? 'option-card-selected' : ''}`}
            >
              <input
                id={id}
                type="radio"
                name={item.name}
                value={choice.value}
                checked={selected}
                onChange={() => onChange(choice.value)}
                className="mt-1 h-5 w-5 accent-accent flex-shrink-0"
              />
              <span className="text-text leading-snug">{choice.label}</span>
            </label>
          );
        })}
      </div>
    </ItemShell>
  );
}
